
module.exports = function setupRoute(/* dependencies from boring */ boring) {

  boring.plugins.active['boring-plugins-default'].initedRoute = true;
};

